import { render, staticRenderFns } from "./Setting.vue?vue&type=template&id=308ecc22&scoped=true&xmlns%3Ael-col=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml&"
import script from "./Setting.vue?vue&type=script&lang=js&"
export * from "./Setting.vue?vue&type=script&lang=js&"
import style0 from "./Setting.vue?vue&type=style&index=0&id=308ecc22&prod&scoped=true&lang=scss&"
import style1 from "./Setting.vue?vue&type=style&index=1&id=308ecc22&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308ecc22",
  null
  
)

export default component.exports